import React, { useMemo, useState } from 'react';

import { IExerciseOption } from '../../../../types/interfaces/exercise-option';
import { IProgramSetItemOption } from '../../../../types/interfaces/program-set-item-option';
import { ITrainingSetItemOption } from '../../../../types/interfaces/training-set-item-option';
import AppOptionTextField from '../../../designe/textfields/app-option-text-field/AppOptionTextField';
import { IOptionValidator } from '../interfaces';

export default function SetItemOptionEdit({
  optionValidators,
  exerciseOptions,
  option,
  onChange,
  valueFieldName,
  additionalFieldName,
}: {
  exerciseOptions: IExerciseOption[];
  option: IProgramSetItemOption | ITrainingSetItemOption;
  onChange: (value: IProgramSetItemOption | ITrainingSetItemOption) => void;
  valueFieldName: string;
  additionalFieldName?: string;
  optionValidators: IOptionValidator[];
}) {
  const exerciseOption = exerciseOptions?.find((e) => e.id === option.optionId);
  const [wasBlurred, setWasBlurred] = useState(false);

  const error = useMemo(() => {
    if (!wasBlurred) {
      return { isError: false, message: '' };
    }

    const validator = optionValidators?.find(
      (validator) =>
        (!validator.type || validator.type === exerciseOption?.type) &&
        validator.validator(option[valueFieldName]),
    );

    return {
      isError: !!validator,
      message: validator?.message,
    };
  }, [option, optionValidators, wasBlurred]);

  return (
    <AppOptionTextField
      onBlur={() => setWasBlurred(true)}
      placeholder={exerciseOption?.name}
      endAdornment={exerciseOption?.unit}
      value={option[valueFieldName]}
      fullWidth
      onChange={(value: number) => {
        const updatedOption = {
          ...option,
          [valueFieldName]: value,
        };

        if (additionalFieldName) {
          updatedOption[additionalFieldName] = value;
        }

        onChange(updatedOption);
      }}
      type={exerciseOption?.type}
      error={error.isError}
      helperText={error.message}
    />
  );
}
